// LEVEL ACTION TYPES

export const FETCH_LEVELS_REQUEST = 'FETCH_LEVELS_REQUEST';
export const FETCH_LEVELS_SUCCESS = 'FETCH_LEVELS_SUCCESS';
export const FETCH_LEVELS_FAILURE = 'FETCH_LEVELS_FAILURE';

export const ADD_LEVEL_REQUEST = 'ADD_LEVEL_REQUEST';
export const ADD_LEVEL_SUCCESS = 'ADD_LEVEL_SUCCESS';
export const ADD_LEVEL_FAILURE = 'ADD_LEVEL_FAILURE';

export const UPDATE_LEVEL_REQUEST = 'UPDATE_LEVEL_REQUEST';
export const UPDATE_LEVEL_SUCCESS = 'UPDATE_LEVEL_SUCCESS';
export const UPDATE_LEVEL_FAILURE = 'UPDATE_LEVEL_FAILURE';

export const DELETE_LEVEL_REQUEST = 'DELETE_LEVEL_REQUEST';
export const DELETE_LEVEL_SUCCESS = 'DELETE_LEVEL_SUCCESS';
export const DELETE_LEVEL_FAILURE = 'DELETE_LEVEL_FAILURE';

export const SET_LEVEL_FIELD_ERRORS = "SET_LEVEL_FIELD_ERRORS";

